import React from 'react'
import LightBox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import httpClient from './myapi'
const _webserver = httpClient.WebServer + '/imgs/gallery/';


class MyLightBox extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            allImgs: props.allImgs,
            // showLightBox: false,
            photoIndex: props.photoIndex

        }
    }
    componentWillReceiveProps(props){
        this.setState({
            allImgs: props.allImgs
        })
        console.log(props.allImgs);
    }
    render(){
        const { allImgs, photoIndex } = this.state;
        return(
            <div>
                { allImgs.length &&
            <LightBox
                mainSrc={_webserver + allImgs[photoIndex].srcnm}
                nextSrc={_webserver + allImgs[(photoIndex + 1) % allImgs.length].srcnm}
                prevSrc={_webserver + allImgs[(photoIndex + allImgs.length - 1) % allImgs.length].srcnm}
                
                onCloseRequest={this.props.closeHandler}
                onMovePrevRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + allImgs.length - 1) % allImgs.length,
                            })
                        }
                
                onMoveNextRequest={() =>
                    this.setState({
                        photoIndex: (photoIndex + 1) % allImgs.length,
                    })
                }
            />
                }
            </div>
        )
}
}
export default MyLightBox;


// WEBPACK FOOTER //
// ./src/MyLightBox.jsx